import { render } from "./Accordion.vue?vue&type=template&id=a6385adc"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"
script.render = render

export default script